import type { MouseEvent } from 'react';

export type ButtonAction =
    | ((event: MouseEvent<HTMLButtonElement>) => Promise<void>)
    | ((event: MouseEvent<HTMLButtonElement>) => void);

export enum ButtonVariant {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    DARK = 'dark',
}

export enum ButtonSize {
    DEFAULT = 'default',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    CONTENT = 'content',
}
